(() => {
  const copyText = async (text) => {
    try {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(text);
        return true;
      }
    } catch (_) {}
    // Fallback old browsers
    const ta = document.createElement("textarea");
    ta.value = text;
    ta.setAttribute("readonly", "");
    ta.style.position = "fixed";
    ta.style.top = "-9999px";
    document.body.appendChild(ta);
    ta.select();
    const ok = document.execCommand("copy");
    document.body.removeChild(ta);
    return ok;
  };

  document.addEventListener("click", async (e) => {
    const btn = e.target.closest(".share-button");
    if (!btn) return;

    const url = btn.dataset.shareUrl;
    const title = btn.dataset.shareTitle || document.title;

    if (!url) return;

    if (navigator.share) {
      try {
        await navigator.share({ title, url });
        return;
      } catch (_) {
        // user cancelled -> ignore
      }
    }

    const ok = await copyText(url);
    if (ok) {
      btn.classList.add("is-copied");
      window.setTimeout(() => btn.classList.remove("is-copied"), 1200);
    }
  });
})();
